const NotaWystawil = () => {

    return (
        <section
            style={{
                margin: '20mm 10mm 0 0',
                fontSize: '13px',
                display: "flex",
                justifyContent: "flex-end"
            }}
        >
            <div style={{whiteSpace: "pre-line"}}>
                <span style={{lineHeight: "1.5rem"}}>
                    {`Notę wystawił/a:\nKatarzyna Stanek`}
                </span>
            </div>
        </section>
    )
}

export default NotaWystawil;